export const API_ENDPOINT = "https://github.com/collective/awesome-volto";
export const AWESOME_VOLTO_MD_ENDPOINT = "https://raw.githubusercontent.com/collective/awesome-volto/master/README.md";
export const CACHE_ENDPOINT = "https://raw.githubusercontent.com/bipoza/volto-addons/main/cache/cache.json";
export const DB_KEYS = {
    ADDONS: 'addons'
}
export const CATEGORIES = [{
    name: "Rich text editing",
    description: "Enhance the basic text editing experience",
    slug: "rich-text-editing"
},
{
    name: "Layout addons",
    description: "Enhancements to the way blocks can be used, to create custom layouts",
    slug: "layout-addons"
},
{
    name: "Widgets",
    description: "Input components, to be reused in the form library",
    slug: "widgets"
}
// , {
//     name: "Various",
//     description: "Various addons that can't fit in a specific category",
//     slug: "various"
// }

];


export const ADDONS_REPO = [{
    title: 'volto-grid-block',
    description: 'A block sistem to...',
    image: 'https://i.picsum.photos/id/98/536/354.jpg?hmac=bXkGljIuCAlgNitm7wIO-UM-3MhJpJ9rs4I1dSaT5KI',
    category: 'Rich text editing'
}, {
    title: 'volto-layout-block',
    description: 'A block sistem to...',
    image: 'https://i.picsum.photos/id/98/536/354.jpg?hmac=bXkGljIuCAlgNitm7wIO-UM-3MhJpJ9rs4I1dSaT5KI',
    category: 'lLayout addons'
}, {
    title: 'volto-widget-block',
    description: 'A block sistem to...',
    image: 'https://i.picsum.photos/id/98/536/354.jpg?hmac=bXkGljIuCAlgNitm7wIO-UM-3MhJpJ9rs4I1dSaT5KI',
    category: 'Widgets'
}, {
    title: 'volto-grid-Widgets',
    description: 'A block sistem to...',
    image: 'https://i.picsum.photos/id/98/536/354.jpg?hmac=bXkGljIuCAlgNitm7wIO-UM-3MhJpJ9rs4I1dSaT5KI',
    category: 'Widgets'
}]